import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { AccountSettings } from "@/src/components/AccountSettings.tsx";

const AccountSettingsPage: React.FC = () => {
  return <AccountSettings />;
};

export const Route = createFileRoute("/settings/account")({
  component: AccountSettingsPage,
});
